<template>
  <div id="app" :style="{ background: bgColor }">
    <any-component v-for="(item, index) in pageData.layer" :layer="item" :key="index" />

    <!-- 离线弹窗 -->
    <div v-if="systemParams.isOffline" class="activity-offline">
      <div class="dialog">
        <div class="content">{{ systemParams.contentText }}</div>
        <a class="confirm" :href="systemParams.confirmHref">{{
          systemParams.confirmText || "确定"
        }}</a>
      </div>
    </div>

    <!-- 水印 -->
    <div class="watermark">Powered By Slime</div>
  </div>
</template>
<script>

import BUCImageHandle from '@qsk/img-compress';
import Vue from 'vue';
import {
  EventBus, productionUtil, SlmNativeProxy, getParams, CountDown, CoreUI, VueIntersection,
} from '@qsk/slime-core';
import AnyComponent from './components/AnyComponent.vue';
import packageJson from '../package.json';
import './variable/components';
// 添加图片压缩函数
const hander = new BUCImageHandle({});
Vue.use(EventBus);
Vue.use(VueIntersection, {
  handler: (logData) => {
    if (logData) {
      // eslint-disable-next-line no-param-reassign
      delete logData.event;
      window.sa.track('show', logData);
    }
  },
  duration: 1000, // 在页面可视区域停留时长
});

CoreUI.forEach((item) => {
  Vue.use(item);
});

Vue.prototype.handleImage = hander.imgCompress();
Vue.prototype.nativeApi = new SlmNativeProxy({
  share: window.state.pageData.setting.shareData,
});
Vue.prototype.$env = Object.assign({}, getParams(), {
  isEditMode: false,
});
Vue.prototype.$countDown = new CountDown();

/**
 * state 组件配置数据
 * systemParams 后台系统写入的数据（目前只控制上下线状态）
 */

export default {
  name: 'app',
  components: {
    AnyComponent,
  },
  data() {
    return {
      pageData: window.state.pageData,
      systemParams: window.systemParams,
    };
  },
  computed: {
    bgColor() {
      const color = this.pageData && this.pageData.setting && this.pageData.setting.bgColor;
      return color || '#fff';
    },
  },
  mounted() {
    console.log('dependencies: ', packageJson.dependencies);
    // 开启滚动位置记录
    productionUtil.markScrollPosition();
    productionUtil.resetScrollPosition();
  },
};
</script>

<style lang="scss">
@import "./style/reset.scss";
html,
body {
  height: 100%;
}

#app {
  width: 375px;
  min-height: 100%;
  margin: 0 auto;
  overflow-x: hidden;
  .activity-offline {
    width: 375px;
    height: 100%;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    z-index: 999;
    .dialog {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 200px;
      background: #fff;
      border-radius: 10px;
      text-align: center;
      .content {
        color: #333;
        height: 140px;
        line-height: 140px;
      }
      .confirm {
        color: #333;
        text-decoration: none;
        position: absolute;
        bottom: 0px;
        left: 0px;
        height: 60px;
        width: 100%;
        line-height: 60px;
        border-top: 0.5px solid rgba(0, 0, 0, 0.7);
      }
    }
  }
  .watermark {
    width: 100%;
    text-align: center;
    font-size: 10px;
    line-height: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #E2Ebf0;
    opacity: 0.4;
  }
}
img[lazy=loading] {
  object-fit: contain;
}
img[lazy=error] {
  object-fit: contain;
}
img[lazy=loaded] {
  object-fit: contain;
}
</style>
